import { useEffect } from 'preact/hooks';

function useUpdateErrorsBasedOnValidation(configKey, isValid, setErrors) {
  useEffect(() => {
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      if (isValid) {
        delete updatedErrors[configKey];
      } else {
        updatedErrors[configKey] = window.TMW.Strings.moderateText.errorMessage;
      }

      return updatedErrors;
    });
  }, [isValid]);
}

export default useUpdateErrorsBasedOnValidation;
